<app-registru-genealogic-table
  [registre]="tables$ | async"
  [registreLength]="total$ | async"
  [loadingDataSpinner]="loadingDataSpinner"
  [dataChanged]="dataChanged"
  (filterData)="filterSearchData($event)"
  (pageSizeChanged)="changePageSize($event)"
  (pageNumberChanged)="changePageNumber($event)"
></app-registru-genealogic-table>
